<!-- 底部版权及备案信息 -->
<template>

<center>
  <h3>友情链接</h3>
  <div>
   <a href="http://www.gov.cn/" target="_blank">中国政府网</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <a href="http://www.mps.gov.cn/" target="_blank">中国公安部</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <a href="http://www.119.gov.cn/" target="_blank">应急管理部消防救援局</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <a href="http://yjgl.gd.gov.cn/" target="_blank">广东省应急管理厅</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <a href="http://gdfire.gd.gov.cn/" target="_blank">广东省消防救援总队</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </div>
  <div>
    <a href="http://www.cfpa.cn/manage/html/index.html" target="_blank">中国消防协会</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.sh70119.com/" target="_blank">上海市消防协会网</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.119tjxf.com/" target="_blank">天津市消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://xfxh.cqfire.com/" target="_blank">重庆市消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.hljxfxh.com/" target="_blank">黑龙江省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </div>
  <div>
    <a href="http://www.jlsxfxh.com/" target="_blank">吉林省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.nx119.org.cn/" target="_blank">宁夏消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.jfpa.com.cn/" target="_blank">江苏省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.ah119.cn/index.html" target="_blank">安徽省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.hnfpa.cn/" target="_blank">河南省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </div>
  <div>
    <a href="http://www.hn119.gov.cn/" target="_blank">湖南省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.sc119.cc/" target="_blank">四川省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.jxfpa.com/" target="_blank">江西省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.yn119.cn/" target="_blank">云南省消防协会网</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.beijingfire.com/" target="_blank">北京消防协会网</a>                    
  </div>
  <div>
    <a href="http://www.gdfpa.cn/" target="_blank">广东省消防科普中心</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="http://www.gdfpa.cn/" target="_blank">广东省消防协会</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                 
  </div>
  <br> 
  <h10>
      版权所有 广东省消防科普中心 广东省消防协会
  </h10>
     <p></p>
  <a
    v-for="(eco, i) in ecosystem1"
    :key="i"
    :href="eco.href"
    
    target="_blank"
  >
    
      {{ eco.text }}
    
      </a>
  <div style="width:300px;margin:0 auto; padding:20px 0;">
	<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602008782" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
  <img src="../../assets/备案图标.png" style="float:left;"/>
  <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44010602008782号</p>
  </a>
	</div>    
  </center>

  
</template>

<script>
  export default {
    name: 'BottomFooter',

    data: () => ({
      ecosystem1: [
        {
          text: '粤ICP备2021000236号-1',
          href: 'https://beian.miit.gov.cn/',
        },
              ],
      
    }),
  }
  
</script>
